<template>
  <div @click="$emit('toggleShow')">
    <div
      v-show="show"
      class="v-fade book-export__notification"
      @click="$event.stopPropagation()"
    >
      <div class="popup__close">
        <button @click="$emit('toggleShow')">
          <span
            class="book-export__kindle-popup-close-icon iconfont iclose-thin"
          ></span>
        </button>
      </div>
      <div>
        <h2 class="book-export__notification-title">
          We've sent the guide to your Kindle device
        </h2>
        <p class="book-export__notification-text">
          You may get an email with the subject line "Verify your Kindle
          document".
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()

defineEmits<{
  (e: 'toggleShow'): void
}>()
</script>
